import {
    AppConfigModel,
    BuildInfoModel,
    RouteDictionary,
    UrlConfigModel,
    UserModel
} from '@models/shared/shared-models';
import { apiUrlStore } from './api-url-store';

export const environment = {
    maintenance: false,
    hmr: true,
    urlStore: getUrlStore(),
    appConfig: {} as AppConfigModel,
    buildInfo: {} as BuildInfoModel,
    userInfo: {} as UserModel,
    routeDictionary: {} as RouteDictionary,
    activeTenants: [],
    recaptcha: {
        siteKey: '6LfDffcpAAAAADa_zTBtiZyy9Oq3LP7tsoc_mhCx',
    },
};

function getUrlStore() {
    let apiList = apiUrlStore;

    configure('@careApi', apiList, false);
    return apiList;
}

function configure(name: string, apiList: UrlConfigModel[], useLocal: boolean, overrideUrl = '') {
    let subList = apiList.filter(x => x.alias == name);
    if (subList.length > 0) {
        if (overrideUrl && overrideUrl.length > 0) {
            subList[0].overrideUrl = overrideUrl;
            return;
        }

        subList[0].useLocal = useLocal;
    }
}